<template>
  <div>
    <BylawsSection />
  </div>
</template>

<script setup lang="ts">
import BylawsSection from '@/components/BylawsSection.vue';

useHead({
  title: 'Official League Bylaws | The Players League DFW Rules',
  meta: [
    { name: 'description', content: 'Access the official league bylaws and rules for The Players League DFW. Understand the regulations, player conduct, and operational procedures.' },
    { property: 'og:title', content: 'Official League Bylaws | The Players League DFW Rules' },
    { property: 'og:description', content: 'Access the official league bylaws and rules for The Players League DFW. Understand the regulations, player conduct, and operational procedures.' },
    { property: 'og:type', content: 'website' },
    { property: 'og:url', content: 'https://theplayersleaguedfw.com/bylaws' },
    { property: 'og:image', content: 'https://theplayersleaguedfw.com/TPLDFW-logo.JPEG' },
    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:title', content: 'Official League Bylaws | The Players League DFW Rules' },
    { name: 'twitter:description', content: 'Access the official league bylaws and rules for The Players League DFW. Understand the regulations, player conduct, and operational procedures.' },
    { name: 'twitter:image', content: 'https://theplayersleaguedfw.com/TPLDFW-logo.JPEG' }
  ]
});
</script>
